import { Modal, } from 'antd';
import { cookies } from '../../utils';
const confirm = Modal.confirm;
/**
 * 处理课程，课程包是否在订单购物车状态判断
 */
export const GetIsOrder = (orderStatus, history, courseType, callback, IsAddCart) => {
  const { flg, OrderId, PayStatus } = orderStatus;
  switch (flg) {
    case 0:
      if (PayStatus === 0 && callback) {
        callback();
      }
      break;
    case 1:
      showConfirm({
        title: `该${courseType}已加入购物车`,
        content: `是否跳转到购物车页面继续购买？`,
        onOk: () => history.push('/cart'), //跳转到购物车页面页面
      });
      break;
    case 5:
      if (PayStatus === 0) {
        showConfirm({
          title: `该${courseType}订单已经生成`,
          content: '是否跳转到支付页面支付？',
          onOk: () => history.push(`/paytype/${OrderId}`), //跳转到订单支付页面
        });
      } else {
        showConfirm({
          title: `该${courseType}已经购买`,
          content: '无需重复购买',
          onOk: () => { }, //跳转到订单支付页面
        });
      }

      break;
    case 9:
      if (PayStatus === 0) {
        showConfirm({
          title: `已有未支付课程包订单包含此课程`,
          content: `是否继续${IsAddCart ? "加入购物车" : "购买"}？`,
          onOk: () => {
            if (callback) {
              callback();
            }
          }, //跳转到订单支付页面
        });
      } else {
        showConfirm({
          title: `该课程已在课程包中购买`,
          content: '无需重复购买',
          onOk: () => { }, //跳转到订单支付页面
        });
      }
      break;
    case 10:
      if (PayStatus === 0) {
        showConfirm({
          title: `已有未支付课程包阶段订单包含此课程`,
          content: `是否继续${IsAddCart ? "加入购物车" : "购买"}？`,
          onOk: () => {
            if (callback) {
              callback();
            }
          }, //跳转到订单支付页面
        });
      } else {
        showConfirm({
          title: `该课程已在课程包中购买`,
          content: `无需重复购买`,
          onOk: () => {
          }, //跳转到订单支付页面
        });
      }
      break;
    case 11:
      showConfirm({
        title: `已有包含此课程的课程包存在于购物车`,
        content: `是否继续${IsAddCart ? "加入购物车" : "购买"}？`,
        onOk: () => {
          if (callback) {
            callback();
          }
        }, //跳转到购物车页面页面
      });
      break;
    case 12:
      showConfirm({
        title: `已有包含此课程的课程包阶段存在于购物车`,
        content: `是否继续${IsAddCart ? "加入购物车" : "购买"}？`,
        onOk: () => {
          if (callback) {
            callback();
          }
        }, //跳转到购物车页面页面
      });
      break;
    case 6:
      if (PayStatus === 0) {
        showConfirm({
          title: `当前课程包阶段已在订单`,
          content: `是否继续${IsAddCart ? "加入购物车" : "购买"}？`,
          onOk: () => {
            if (callback) {
              callback();
            }
          },
        });
      } else {
        showConfirm({
          title: `当前课程包已有阶段被购买`,
          content: `无法直接购买此课程包,请按阶段购买`,
          onOk: () => {
          },
        });
      }

      break;
    case 2:
      showConfirm({
        title: `当前课程包已有课程阶段存在于购物车`,
        content: `是否继续${IsAddCart ? "加入购物车" : "购买"}？`,
        onOk: () => {
          if (callback) {
            callback();
          }
        },
      });
      break;
    case 7:
      if (PayStatus === 1) {
        showConfirm({
          title: `当前课程包已有课程被购买`,
          content: IsAddCart ? "是否继续加入购物车" : '是否继续购买？',
          onOk: () => {
            if (callback) {
              callback();
            }
          },
        });
      } else {
        showConfirm({
          title: `当前课程包已有课程存在待支付订单`,
          content: IsAddCart ? "是否继续加入购物车" : '是否继续购买？',
          onOk: () => {
            if (callback) {
              callback();
            }
          },
        });
      }

      break;
    case 3:
      showConfirm({
        title: `当前课程包包含课程已加入购物车`,
        content: `是否继续${IsAddCart ? "加入购物车" : "购买"}？`,
        onOk: () => {
          if (callback) {
            callback();
          }
        }, //跳转到购物车页面页面
      });
      break;
    case 8:
      if (PayStatus === 0) {
        showConfirm({
          title: `当前阶段已有课程存在待支付订单`,
          content: IsAddCart ? "是否继续加入购物车" : '是否继续购买？',
          onOk: () => {
            if (callback) {
              callback();
            }
          }, //跳转到订单支付页面
        });
      } else {
        showConfirm({
          title: `当前阶段已有课程被购买`,
          content: IsAddCart ? "是否继续加入购物车" : '是否继续购买？',
          onOk: () => {
            if (callback) {
              callback();
            }
          }, //跳转到订单支付页面
        });
      }

      break;
    case 14:
      if (PayStatus === 0) {
        showConfirm({
          title: `当前课程包已存在待支付订单`,
          content: `是否继续${IsAddCart ? "加入购物车" : "购买"}？`,
          onOk: () => {
            if (callback) {
              callback();
            }
          }, //跳转到订单支付页面
        });
      } else {
        showConfirm({
          title: `当前课程包已被购买`,
          content: '无需重新购买阶段',
          onOk: () => { }, //跳转到订单支付页面
        });
      }

      break;
    case 4:
      showConfirm({
        title: `当前阶段已有课程在购物车`,
        content: `是否继续${IsAddCart ? "加入购物车" : "购买"}？`,
        onOk: () => {
          if (callback) {
            callback();
          }
        }, //跳转到购物车页面页面
      });
      break;
    case 13:
      showConfirm({
        title: `当前阶段所属课程包已在购物车`,
        content: `是否继续${IsAddCart ? "加入购物车" : "购买"}？`,
        onOk: () => {
          if (callback) {
            callback();
          }
        }, //跳转到购物车页面页面
      });
      break;
    default:
      break;
  }
};
function showConfirm(obj) {
  confirm({
    title: obj.title,
    content: obj.content,
    onOk() {
      obj.onOk();
    },
    okText: '确认',
    cancelText: '取消',
    onCancel() { },
  });
}
/**
 * 退出登录
 */
export const logout = history => {
  cookies.delCookie('UserKey');
  cookies.delCookie('UserNameKey');
  cookies.delCookie('UserPhoneKey');
  cookies.delCookie('sessionId');
  localStorage.removeItem('studentinfo');
  localStorage.removeItem('subject');
  history.push('/login');
};
/**
 * 验证手机号码
 */
export const checkPhone = value => {
  const phone = /^[1][3,4,5,6,7,8,9][0-9]{9}$/; //应该前后都可以有空格自动去掉
  if (value && value.trim() !== '' && !phone.test(value)) {
    return false;
  }
  return true;
};
/**
 * 验证身份证号
 */
export const checkCardNum = value => {
  const cardNum = /^[1-9]{1}[0-9]{14}$|^[1-9]{1}[0-9]{16}([0-9]|[xX])$/;
  if (value && value.trim() !== '' && !cardNum.test(value)) {
    return false;
  }
  return true;
};

/**
 * 加入购物车动画实现
 */
export const addCartAnim = (callback, stageID) => {
  let imgtodrag, imgtodragImage;
  let viewcart = document.getElementsByClassName('addCartBtn')[0];
  if (stageID) {
    imgtodrag = document.getElementById("stage" + stageID);
    imgtodragImage = imgtodrag.getElementsByTagName('img')[0];
  } else {
    imgtodrag = document.getElementsByClassName('addcartAnim')[0];
    imgtodragImage = imgtodrag.getElementsByTagName('img')[0];
  }
  let disLeft = imgtodragImage.getBoundingClientRect().left;
  let disTop = imgtodragImage.getBoundingClientRect().top;
  let cartleft = viewcart.getBoundingClientRect().left;
  let carttop = viewcart.getBoundingClientRect().top;
  let image = imgtodragImage.cloneNode(true);
  image.style = 'z-index: 1111; width: 100px;opacity:0.8; position:fixed; top:' + disTop + 'px;left:' + disLeft + 'px;transition: left 2s, top 2s, width 2s, opacity 2s cubic-bezier(1, 1, 1, 1)';
  var rechange = document.body.appendChild(image);
  setTimeout(function () {
    image.style.left = cartleft + 'px';
    image.style.top = carttop + 'px';
    image.style.width = '40px';
    image.style.opacity = '0';
  }, 200);
  setTimeout(function () {
    rechange.parentNode.removeChild(rechange);
    if (callback) {
      callback();
    }
  }, 2000);
}
/**
 * 引导页实现实现
 */
let stepIndex = 1, stepCount = 9, callback = null;
export const addGuide = (cb) => {
  //增加遮罩层
  callback = cb;
  addOverLay();
  guide();
}
function guide() {
  let home = document.getElementsByClassName("home-app")[0];
  let element = home.querySelector(`.step${stepIndex}`);
  let overLay = document.querySelector(".guide-overlay");
  if (element) {
    let rect = element.getBoundingClientRect();
    let arrow = document.createElement("img");
    arrow.setAttribute('src', require(`../../images/guide/arrow${stepIndex}.png`));
    arrow.className = "guide-absolutePosition";
    arrow.style.cssText = cssText(rect).arrow;
    let tip = document.createElement("img");
    tip.setAttribute('src', require(`../../images/guide/tip${stepIndex}.png`));
    tip.className = "guide-absolutePosition";
    tip.style.cssText = cssText(rect).tip;
    let nextBtn = document.createElement("img");
    nextBtn.setAttribute('src', require('../../images/guide/iknow.png'))
    nextBtn.className = "guide-absolutePosition";
    nextBtn.style.cssText = cssText(rect).nextBtn;
    nextBtn.addEventListener('click', () => {
      if (stepIndex === stepCount) {
        removeOverLay();
        recoverScroll();
        window.notShowModal = false;
        let step = document.querySelector(".guide-relativePosition");
        step && step.classList.remove("guide-relativePosition", "guide-showElemnt");
        stepIndex = 0;
        if (callback) {
          callback();
        }
      } else {
        next();
      }
    }, false);
    overLay.appendChild(nextBtn);
    overLay.appendChild(arrow);
    overLay.appendChild(tip);
    if (stepIndex === 1) {
      addHelpLayer(rect);
    } else {
      moveHelpLayer(rect);
    }
    element.classList.add("guide-relativePosition", "guide-showElemnt");

    if (stepIndex === 7) {
      window.notShowModal = true;
      window.routeHistory.replace("/center/startExer/0");
    }
  }
}
function cssText(rect) {
  switch (stepIndex) {
    case 1:

      return {
        arrow: `top:${rect.top + rect.height + 10}px;left:${rect.left + 5}px;`,
        tip: `top:${rect.top + rect.height + 148}px;left:${rect.width + rect.left}px;`,
        nextBtn: `top:${rect.top + rect.height + 188}px;left:${rect.width + rect.left + 50}px;cursor:pointer;`,
      };
    case 2:
      return {
        arrow: `top:${rect.top + rect.height + 10}px;left:${rect.left + 5}px;`,
        tip: `top:${rect.top + rect.height + 148}px;left:${rect.left + 5}px;`,
        nextBtn: `top:${rect.top + rect.height + 228}px;left:${rect.left + 50}px;cursor:pointer;`
      }
    case 3:
      return {
        arrow: `top:${rect.top + rect.height + 10}px;left:${rect.left + rect.width - 50}px;`,
        tip: `top:${rect.top + rect.height + 30}px;left:${rect.left + rect.width + 50}px;`,
        nextBtn: `top:${rect.top + rect.height + 140}px;left:${rect.left + rect.width + 200}px;cursor:pointer;`
      }
    case 4:
      return {
        arrow: `top:${rect.top + rect.height + 10}px;left:${rect.left + rect.width - 50}px;`,
        tip: `top:${rect.top + rect.height}px;left:${rect.left + rect.width + 60}px;`,
        nextBtn: `top:${rect.top + rect.height + 110}px;left:${rect.left + rect.width + 200}px;cursor:pointer;`
      }
    case 5:
      return {
        arrow: `top:${rect.top - 150}px;left:${rect.left + rect.width - 50}px;`,
        tip: `top:${rect.top - 150}px;left:${rect.left + rect.width + 80}px;`,
        nextBtn: `top:${rect.top - 60}px;left:${rect.left + rect.width + 200}px;cursor:pointer;`
      }
    case 6: {
      return {
        arrow: `top:${rect.top - 10}px;left:${rect.left - 80}px;`,
        tip: `top:${rect.top + 140}px;left:${rect.left - 200}px;`,
        nextBtn: `top:${rect.top + 190}px;left:${rect.left - 90}px;cursor:pointer;`
      }
    }
    case 7: {
      return {
        arrow: `top:${rect.top - 123}px;left:${rect.left - 127}px;`,
        tip: `top:${rect.top - 163}px;left:${rect.left - 517}px;`,
        nextBtn: `top:${rect.top - 70}px;left:${rect.left - 447}px;cursor:pointer;`
      }
    }
    case 8: {
      return {
        arrow: `top:${rect.top + rect.height + 10}px;left:${rect.left - rect.width - 30}px;`,
        tip: `top:${rect.top + rect.height + 150}px;left:${rect.left - rect.width - 170}px;`,
        nextBtn: `top:${rect.top + rect.height + 200}px;left:${rect.left - rect.width - 100}px;cursor:pointer;`
      }
    }
    case 9: {
      return {
        arrow: `top:${rect.top + rect.height + 10}px;left:${rect.left - 40}px;`,
        tip: `top:${rect.top + rect.height + 170}px;left:${rect.left}px;`,
        nextBtn: `top:${rect.top + rect.height + 230}px;left:${rect.left + 70}px;cursor:pointer;`
      }
    }
    default:
      break;
  }
}
function next() {
  let overLay = document.querySelector(".guide-overlay");
  let home = document.getElementsByClassName("home-app")[0];
  let element = home.querySelector(`.step${stepIndex}`);
  element.classList.remove("guide-relativePosition", "guide-showElemnt");

  while (overLay.hasChildNodes()) //当div下还存在子节点时 循环继续 
  {
    overLay.removeChild(overLay.firstChild);
  }
  stepIndex++;
  guide();
}
function addOverLay() {
  //禁止滚动
  forbidScroll();
  let overLay = document.createElement("div");
  overLay.className = "guide-overlay";
  overLay.style.cssText = "top: 0px;bottom: 0px;left: 0px;right: 0px;position: fixed;opacity: 0.8;";
  let jumpBtn = document.createElement("img");
  jumpBtn.className = "guide-jumpBtn";
  jumpBtn.setAttribute('src', require('../../images/guide/jump.png'));
  jumpBtn.addEventListener("click", () => {
    removeOverLay();
    recoverScroll();
    window.notShowModal = false;
    let step = document.querySelector(".guide-relativePosition");
    step && step.classList.remove("guide-relativePosition", "guide-showElemnt");
    if (callback) {
      callback();
    }
  }, false);
  document.body.appendChild(jumpBtn);
  document.body.append(overLay);
}
function removeOverLay() {
  let overLay = document.querySelector(".guide-overlay");
  let helperLayer = document.querySelector(".guide-helperLayer");
  let jumpBtn = document.querySelector('.guide-jumpBtn');

  document.body.removeChild(overLay);
  jumpBtn && document.body.removeChild(jumpBtn);
  helperLayer && document.body.removeChild(helperLayer);

}
function addHelpLayer(rect) {
  let helperLayer = document.createElement("div");

  helperLayer.className = "guide-helperLayer";
  helperLayer.style.cssText = `width:${rect.width}px;height:${rect.height}px;top:${rect.top}px;left:${rect.left}px;`;

  document.body.append(helperLayer);
}
function moveHelpLayer(rect) {
  let helperLayer = document.querySelector(".guide-helperLayer");
  if (helperLayer) {
    helperLayer.style.cssText = `width:${rect.width}px;height:${rect.height}px;top:${rect.top}px;left:${rect.left}px;`;
  }
}
function forbidScroll() {
  document.body.style.cssText += "overflow:hidden;"
}
function recoverScroll() {
  document.body.style.cssText -= "overflow:hidden;"
}


// WEBPACK FOOTER //
// ./src/utils/tools/common.js